import { usePanachagesStore } from "@/store/panachages";
import { useContextStore } from "@/store/context";
import { useDatalayerStore } from "@/store/datalayer";

import ProductSheetCodes from "@/utils/product-sheet-codes";
import { pushProps, usePush } from "../mixins/push-mixin";


export const pageProductSheetProps = () => ({
  shopId: {
    type: Number,
    required: true
  },
  breadcrumb: {
    type: Array,
    required: true
  },
  product: {
    type: Object,
    required: true
  },
  reviews: {
    type: Object,
    required: false,
    default: {}
  },
  statistics: {
    type: Object,
    required: true
  },
  backButton: {
    type: Boolean,
    required: false,
    default: true
  },
  isReplacedByNational: {
    type: Boolean,
    required: false,
    default: false
  },
  isPopin: {
    type: Boolean,
    required: false,
    default: false
  },
  fromProspectus: {
    type: Boolean,
    required: false,
    default: false
  },
  ...pushProps()
})

export const usePageProductSheet = (props) => {

  const { getPushData } = usePush(props.pushZones)

  const hasSyndigoContent = ref(false)

  const { setLocation } = useDatalayerStore()

  const { productMixes } = storeToRefs(usePanachagesStore());
  const { displayMode, fromUrl } = storeToRefs(useContextStore());


  const productInfo = computed(() => {
    return props.product.attributes;
  })
  const photos = computed(() => {
    const photos = productInfo.value.photos;
    const video = productInfo.value.video;
    let finalPhotos = [];
    if (photos) {
      finalPhotos = photos.map((photo, i) => ({
        url: photo,
        alt: `photo${i}`,
        type: "image"
      }));
    }
    if (video) {
      finalPhotos.push({
        url: video,
        alt: `video${photos.length}`,
        type: "video"
      })
    }
    return finalPhotos
  })
  const pushZoneTitle = computed(() => {
    if (productInfo.value.associations) {
      if (productInfo.value.associations.alternatifs && productInfo.value.associations.alternatifs.data && productInfo.value.associations.alternatifs.data.length > 0) {
        return "Produits alternatifs"
      } else if (productInfo.value.associations.similaire && productInfo.value.associations.similaire.data && productInfo.value.associations.similaire.data.length > 0) {
        return "Avez-vous pensé à..."
      }
    } else {
      return ""
    }
  })
  const recettePosition = computed(() => {
    return useRuntimeConfig().public.MIAM_FICHE_PRODUIT_POSITION;
  })

  const hasReviews = computed(() => {
    return productInfo.value.reviews_count >0 && props.reviews && props.reviews.data;
  });

  const mounted = () => {
    setLocation("FicheProduit");
    if (props.product) {
      window.SYNDI = window.SYNDI || [];
      window.SYNDI.push(props.product.id);
      window.SYNDI.push({
        contentCallback: (hasContent) => {
          if (hasContent) {
            hasSyndigoContent.value = true;
          }
        }
      });
    }
  }

  return {
    hasSyndigoContent,
    ProductSheetCodes,
    productMixes,
    displayMode,
    fromUrl,
    productInfo,
    photos,
    pushZoneTitle,
    recettePosition,
    getPushData,
    hasReviews,
    mounted
  }
}